export default __webpack_public_path__ + "static/media/how_to_2.eec207d7.jpg";